import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { redirectToLogin } from '../utils/loginRedirect';

export default function DashboardProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    redirectToLogin();
    return null;
  }

  return children;
}
